import moment from 'moment-timezone';

export const DEFAULT_PLAN_RELATIVE = 'true';
export const DEFAULT_PLAN_GROUPED_BY = 'FruitClass';
export const DEFAULT_PLAN_PERIOD_TYPE = 'week';
export const DEFAULT_PLAN_TIMELINE_DATE = moment().format('YYYY-MM-DD');

